import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../css/Header6.css";

const Header6 = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="header6">

        {/* LEFT BRAND */}
        <div className="h6-left">
          <div className="h6-logo">GRIT</div>
        </div>

        {/* CENTER NAV */}
        <nav className="h6-nav">
          <NavLink to="/" end>Home</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/workouts">Workouts</NavLink>
          <NavLink to="/services">Services</NavLink>
          <NavLink to="/plans">Plans</NavLink>
          <NavLink to="/gallery">Gallery</NavLink>
          <NavLink to="/trainers">Trainers</NavLink>
          <NavLink to="/faqs">FAQs</NavLink>
        </nav>

        {/* RIGHT META */}
        <div className="h6-right">
          <div className="h6-meta">
            <span>EST. 2016</span>
            <span className="sep"></span>
            <span>URBAN TRAINING LAB</span>
          </div>

          <div
            className={`h6-ham ${open ? "open" : ""}`}
            onClick={() => setOpen(!open)}
          >
            <span></span>
            <span></span>
          </div>
        </div>

      </header>

      {/* MOBILE MENU */}
      <div className={`h6-mobile ${open ? "show" : ""}`}>
        <nav className="h6-mobile-nav">
          <NavLink to="/" onClick={() => setOpen(false)}>Home</NavLink>
          <NavLink to="/about" onClick={() => setOpen(false)}>About</NavLink>
          <NavLink to="/workouts" onClick={() => setOpen(false)}>Workouts</NavLink>
          <NavLink to="/services" onClick={() => setOpen(false)}>Services</NavLink>
          <NavLink to="/plans" onClick={() => setOpen(false)}>Plans</NavLink>
          <NavLink to="/gallery" onClick={() => setOpen(false)}>Gallery</NavLink>
          <NavLink to="/trainers" onClick={() => setOpen(false)}>Trainers</NavLink>
          <NavLink to="/faqs" onClick={() => setOpen(false)}>FAQs</NavLink>
          <NavLink to="/contact" onClick={() => setOpen(false)}>Contact</NavLink>
        </nav>
      </div>
    </>
  );
};

export default Header6;
